import React from "react";
import { useFormikContext } from "formik";

export interface SubmitButtonProps<T = any> {
	component: React.ComponentType<T>;
	children?: React.ReactChild | React.ReactFragment | React.ReactPortal;
	purpose?: string;
	type?: string;
	onClick?: (evt: React.MouseEvent) => void;
	classes?: string;
	icon?: string;
	ariaLabel?: string;
	customBusyIcon?: React.ReactNode;
	disabled?: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ children, component, ...props }) => {
	const isBusy = useFormikContext()?.isSubmitting;
	type ButtonProps = React.ComponentProps<typeof component>;
	return React.createElement(component, { ...(props as ButtonProps), busy: isBusy }, children);
};

export default SubmitButton;
